import React, { useState, useEffect, useRef } from "react";
import { useTheme } from "../context/ThemeContext";
import { spacing } from "../utils/tokens";
import Typography from "./Typography";

import Ticker from "./Ticker";  
import assets from "../models/assets.json";


function TickerHeader() {
    const { theme } = useTheme();

    const styles = {
        container: {
          display: "flex",
          width: "100%",
          height: "47px",
          padding: `0 ${spacing.s}`,
          paddingLeft: spacing.s,
          paddingRight: spacing.s,
          boxSizing: "border-box",
          gap: spacing.s,
          overflowX: "scroll",
          background: theme.colors.fillPrimary,
          justifyContent: "flex-start",
          alignItems: "center",
          borderTop: `1px solid ${theme.colors.fillSecondary}`,
          borderBottom: `1px solid ${theme.colors.fillSecondary}`,
        },
      };

      console.log("Ticker activated");

    return (
      <div style={styles.container}>
        {assets.map((ticker, index) => (
            <Ticker 
              key={index} 
              stockSymbol={ticker.stockSymbol} 
              percentage={`${ticker.percentage}%`} 
              delta={ticker.delta} 
            />
          ))}
      </div>
    );
}

export default TickerHeader;